export default [  
  {
    path: '/customers',
    name: 'customers',
    component: () => import('@/views/modules/customers/list'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Customers List',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Customers' }
      ]
    },
    children:[
      {
        path: '/customers/create',
        name: 'customers-create',
        component: () => import('@/views/modules/customers/create'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Customer Create',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Customers', link: '/customers' },
            { text: 'Create' }
          ]
        }
      },
      {
        path: '/customers/upload',
        name: 'customers-upload',
        component: () => import('@/views/modules/customers/upload'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Customer Upload',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Customers', link: '/customers' },
            { text: 'Upload' }
          ]
        }
      },
      {
        path: '/customers/:id/edit',
        props: true,
        name: 'customers-edit',
        component: () => import('@/views/modules/customers/edit'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Customers Edit',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Customer',  to: { name: "customers-show" }, param: 'id' },
            { text: 'Edit' }
          ]
        }
      },
      {
        path: '/customers/:id/show',
        props: true,
        name: 'customers-show',
        component: () => import('@/views/modules/customers/show'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Customers Details',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Customers',  to: { name: "customers" } },
            { text: 'Details' }
          ]
        }
      },
    
    ]
  },
  {
    path: '/customers-balances',
    name: 'customers-balances',
    component: () => import('@/views/modules/customers/balances'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Rep - Customer Details',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Customer Details' }
      ]
    },
  }
 
]